export const END_POINTS = {
    partnerDetails: '/afs/api/partner/partnersDetailsByNameSpace',
};

export const PAGE_SIZE = 10;